import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { ModuleModel } from 'src/app/models/authentication/module.model';
import { BreadcrumbModel } from 'src/app/models/common/breadcrumb.module';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {

  private breadcrumbsSubject = new BehaviorSubject<BreadcrumbModel[]>([]);
  breadcrumbs$ = this.breadcrumbsSubject.asObservable();
  private modules: ModuleModel[] = [];

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updateBreadcrumbs(event.urlAfterRedirects);
    });
  }

  setModules(modules: ModuleModel[]) {
    this.modules = modules;
    // Forzar recálculo en la URL actual
    const currentUrl = this.router.url;
    this.updateBreadcrumbs(currentUrl);
  }

  private updateBreadcrumbs(currentUrl: string) {
    if (!this.modules.length || !currentUrl) return;

    const cleanedUrl = currentUrl.split('?')[0].split('#')[0].replace(/^\/+/, '');
    const normalizedUrl = `/${cleanedUrl}`;

    const breadcrumbs: BreadcrumbModel[] = [];

    for (const module of this.modules) {
      if (!module.windows?.length) continue;

      for (const window of module.windows) {
        const windowPath = `/${window.urlWindow}`;

        if (windowPath === normalizedUrl) {
          breadcrumbs.push(
            { label: module.name, url: `/${module.urlModule}` },
            { label: window.labelName, url: windowPath }
          );
          this.breadcrumbsSubject.next(breadcrumbs);
          return;
        }

        if (normalizedUrl.startsWith(`${windowPath}/`)) {
          breadcrumbs.push(
            { label: module.name, url: `/${module.urlModule}` },
            { label: window.labelName, url: windowPath },
            { label: 'Captura', url: '' }
          );
          this.breadcrumbsSubject.next(breadcrumbs);
          return;
        }
      }

      const modulePath = `/${module.urlModule}`;
      if (modulePath === normalizedUrl) {
        breadcrumbs.push({ label: module.name, url: modulePath });
        this.breadcrumbsSubject.next(breadcrumbs);
        return;
      }
    }

    this.breadcrumbsSubject.next([]);
  }

}
